module.exports = __webpack_public_path__ + "img/744.dc40d287.jpg";